
export const portfolioItems = [
  {
    id: 1,
    title: 'Modern Master Bathroom',
    category: 'Bathroom',
    image: 'https://public.readdy.ai/ai/img_res/ff81c9d6ae481f6b33bcc350371d29c6.jpg',
    likes: 124,
  },
  {
    id: 2,
    title: 'Contemporary Kitchen Renovation',
    category: 'Kitchen',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20contemporary%20kitchen%20renovation%20white%20shaker%20cabinets%20large%20quartz%20island%20with%20waterfall%20edge%20stainless%20steel%20appliances%20subway%20tile%20backsplash%20pendant%20lights%20warm%20wood%20flooring%20bright%20natural%20light%20professional%20real%20estate%20photography%20style&width=600&height=600&seq=insta-kitchen1&orientation=squarish',
    likes: 203,
  },
  {
    id: 3,
    title: 'Exterior House Painting',
    category: 'Painting',
    image: 'https://readdy.ai/api/search-image?query=freshly%20painted%20house%20exterior%20modern%20gray%20color%20scheme%20with%20crisp%20white%20trim%20clean%20professional%20finish%20beautiful%20curb%20appeal%20manicured%20landscaping%20blue%20sky%20sunny%20day%20professional%20photography%20warm%20tones%20residential%20home%20improvement&width=600&height=600&seq=insta-paint1&orientation=squarish',
    likes: 89,
  },
  {
    id: 4,
    title: 'Hardwood Floor Installation',
    category: 'Flooring',
    image: 'https://readdy.ai/api/search-image?query=gorgeous%20new%20hardwood%20oak%20floor%20installation%20in%20spacious%20living%20room%20rich%20warm%20wood%20grain%20perfectly%20aligned%20planks%20smooth%20satin%20finish%20natural%20light%20streaming%20through%20windows%20modern%20furniture%20minimal%20staging%20professional%20photography&width=600&height=600&seq=insta-floor1&orientation=squarish',
    likes: 156,
  },
  {
    id: 5,
    title: 'Spa-Like Bathroom Retreat',
    category: 'Bathroom',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20spa%20inspired%20bathroom%20renovation%20freestanding%20white%20soaking%20tub%20natural%20stone%20accent%20wall%20rainfall%20shower%20head%20warm%20wood%20vanity%20soft%20ambient%20lighting%20green%20plants%20serene%20atmosphere%20professional%20interior%20photography&width=600&height=600&seq=insta-bath2&orientation=squarish',
    likes: 278,
  },
  {
    id: 6,
    title: 'Gourmet Kitchen Upgrade',
    category: 'Kitchen',
    image: 'https://readdy.ai/api/search-image?query=upscale%20gourmet%20kitchen%20remodel%20dark%20navy%20blue%20cabinets%20brushed%20gold%20hardware%20white%20marble%20countertops%20professional%20grade%20appliances%20under%20cabinet%20lighting%20open%20shelving%20warm%20wood%20accents%20luxury%20residential%20interior%20photography&width=600&height=600&seq=insta-kitchen2&orientation=squarish',
    likes: 312,
  },
  {
    id: 7,
    title: 'Living Room Interior Paint',
    category: 'Painting',
    image: 'https://readdy.ai/api/search-image?query=beautifully%20painted%20living%20room%20interior%20warm%20greige%20walls%20crisp%20white%20trim%20and%20crown%20molding%20modern%20furniture%20arrangement%20natural%20light%20large%20windows%20cozy%20atmosphere%20professional%20quality%20paint%20finish%20residential%20interior%20photography&width=600&height=600&seq=insta-paint2&orientation=squarish',
    likes: 97,
  },
  {
    id: 8,
    title: 'Guest Bathroom Makeover',
    category: 'Bathroom',
    image: 'https://readdy.ai/api/search-image?query=elegant%20guest%20bathroom%20renovation%20herringbone%20subway%20tile%20shower%20modern%20floating%20vanity%20round%20mirror%20with%20backlight%20matte%20black%20fixtures%20neutral%20warm%20color%20palette%20clean%20minimalist%20design%20professional%20interior%20photography&width=600&height=600&seq=insta-bath3&orientation=squarish',
    likes: 185,
  },
  {
    id: 9,
    title: 'Tile Flooring Project',
    category: 'Flooring',
    image: 'https://readdy.ai/api/search-image?query=elegant%20large%20format%20porcelain%20tile%20flooring%20installation%20in%20open%20concept%20living%20space%20light%20gray%20tiles%20with%20subtle%20veining%20pattern%20perfectly%20aligned%20grout%20lines%20modern%20minimalist%20interior%20natural%20light%20professional%20real%20estate%20photography&width=600&height=600&seq=insta-floor2&orientation=squarish',
    likes: 143,
  },
  {
    id: 10,
    title: 'Drywall Finishing',
    category: 'Drywall',
    image: 'https://readdy.ai/api/search-image?query=perfectly%20smooth%20drywall%20finishing%20in%20new%20construction%20room%20level%20five%20finish%20ready%20for%20paint%20bright%20white%20walls%20clean%20corners%20and%20edges%20professional%20craftsmanship%20construction%20photography%20warm%20lighting%20residential%20interior&width=600&height=600&seq=insta-drywall1&orientation=squarish',
    likes: 67,
  },
  {
    id: 11,
    title: 'Kitchen Before and After',
    category: 'Kitchen',
    image: 'https://readdy.ai/api/search-image?query=stunning%20white%20kitchen%20renovation%20completed%20project%20bright%20open%20layout%20large%20center%20island%20with%20seating%20quartz%20countertops%20modern%20pendant%20lights%20stainless%20steel%20appliances%20herringbone%20backsplash%20warm%20wood%20floors%20professional%20photography&width=600&height=600&seq=insta-kitchen3&orientation=squarish',
    likes: 341,
  },
  {
    id: 12,
    title: 'Accent Wall Painting',
    category: 'Painting',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20accent%20wall%20painting%20in%20bedroom%20deep%20emerald%20green%20feature%20wall%20behind%20bed%20with%20white%20surrounding%20walls%20modern%20furniture%20gold%20accents%20cozy%20bedding%20natural%20light%20professional%20interior%20design%20photography%20warm%20tones&width=600&height=600&seq=insta-paint3&orientation=squarish',
    likes: 198,
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    text: 'BestCall Restor transformed our outdated kitchen into a stunning modern space. Their attention to detail and professionalism exceeded our expectations. The team was punctual, clean, and completed the project on time!',
    rating: 5,
    project: 'Kitchen Remodel'
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    text: 'We hired BestCall Restor for our bathroom renovation and couldn\'t be happier. They handled everything from design to installation flawlessly. Highly recommend their services!',
    rating: 5,
    project: 'Bathroom Remodel'
  },
  {
    id: 3,
    name: 'Jennifer Thompson',
    text: 'The exterior painting job on our home was exceptional. The crew was professional, efficient, and the quality of work is outstanding. Our house looks brand new!',
    rating: 5,
    project: 'Exterior Painting'
  }
];
